// extracted by mini-css-extract-plugin
export default {"active":"onoff_active__8d9kj","activeSwitch":"onoff_activeSwitch__gp0kt","inactive":"onoff_inactive__A2x1R","extra":"onoff_extra__tqXD9","onOffBtn":"onoff_onOffBtn__jHaEG"};